export default {
  palette: {
    primary: {
      light: "#ABC200",
      main: "#333333",
      dark: "#000000",
      contrastText: "#696969",
      // contrastText: '#7f7f7f'
    },
    secondary: {
      light: "#FFFFFF",
      main: "#F2F2F2",
      dark: "#212121",
      contrastText: "#646464",
    },
    // error: will use the default color
  },
  typography: {
    useNextVariants: true,
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "Roboto",
      "Raleway",
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: "2px",
        transition: "all 200ms ease-in",
        "&$raisedPrimary": {
          backgroundColor: "#ABC200",
          color: "#FFFFFF",
        },
        "&$raisedPrimary:hover": {
          backgroundColor: "#92A501",
        },
        "&$raisedSecondary:hover": {
          backgroundColor: "rgb(227, 227, 227)",
        },
        "&$flatSecondary": {
          color: "#646464",
        },
        "&$flatSecondary:hover": {
          backgroundColor: "#e3e3e3",
        },
        "&$flatPrimary": {
          color: "#ABC200",
        },
        "&$flatPrimary:hover": {
          backgroundColor: "#e3e3e3",
        },
        "&$disabled": {
          opacity: 0.45,
        },
      },
    },
    MuiFab: {
      root: {
        transition: "all 200ms ease-in",
        "&$primary": {
          backgroundColor: "#ABC200",
          color: "#FFFFFF",
        },
        "&$primary:hover": {
          backgroundColor: "#92A501",
        },
        "&$secondary:hover": {
          backgroundColor: "rgb(227, 227, 227)",
        },
        "&$disabled": {
          opacity: 0.45,
        },
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: "2px",
        backgroundColor: "#F2F2F2",
      },
    },
    MuiDialogTitle: {
      root: {
        backgroundColor: "#FFFFFF",
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: 500,
        borderBottom: "1px solid #737373",
        padding: "20px",
        color: "#000000",
      },
    },
    MuiDialogContent: {
      root: {
        fontFamily: "Roboto",
        fontSize: "16px",
        fontWeight: 400,
        padding: "20px",
        color: "#757575",
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(0,0,0,0.2)",
      },
    },
    MuiInput: {
      root: {
        "&::after": {
          borderBottom: "1px solid #ABC200 !important",
        },
      },
    },
    MuiAppBar: {
      root: {
        boxShadow: "unset",
        backgroundColor: "#212121",
      },
    },
    MuiSnackbar: {
      root: {
        "& div": {
          borderRadius: "0px !important",
        },
        "& span": {
          fontSize: 14,
        },
      },
    },
    MuiContainer: {
      minWidth: "1024px",
    },
  },
};



// WEBPACK FOOTER //
// ./src/modules/menu/components/pages/MenuTheme.tsx